import { useEffect, useState } from "react";
import Winner from "./Winner";

interface IResult {
  score: number;
  oppScore: number;
}

function Result({ score, oppScore }: IResult) {
  const [player, setPlayer] = useState<number>(-1);

  useEffect(() => {
    if (score > oppScore) {
      setPlayer(1);
    } else if (score < oppScore) {
      setPlayer(2);
    } else {
      setPlayer(0);
    }
  }, [score, oppScore]);

  return (
    <div className="h-full w-full bg-[#0a0a12] flex items-center justify-center p-6 relative overflow-hidden">
      {/* Ambient background orbs depending on win state */}
      <div 
        className={`absolute rounded-full blur-[80px] pointer-events-none w-[300px] h-[300px] top-[20%] left-[20%] transition-colors duration-700 ${
          player === 1 
            ? 'bg-[radial-gradient(circle,rgba(34,197,94,0.15)_0%,transparent_70%)]' 
            : player === 2 
            ? 'bg-[radial-gradient(circle,rgba(239,68,68,0.15)_0%,transparent_70%)]' 
            : 'bg-[radial-gradient(circle,rgba(168,168,168,0.15)_0%,transparent_70%)]'
        }`} 
      />
      <div 
        className={`absolute rounded-full blur-[80px] pointer-events-none w-[300px] h-[300px] bottom-[10%] right-[10%] transition-colors duration-700 ${
          player === 1 
            ? 'bg-[radial-gradient(circle,rgba(16,185,129,0.15)_0%,transparent_70%)]' 
            : player === 2 
            ? 'bg-[radial-gradient(circle,rgba(244,63,94,0.15)_0%,transparent_70%)]' 
            : 'bg-[radial-gradient(circle,rgba(203,213,225,0.15)_0%,transparent_70%)]'
        }`} 
      />

      <Winner 
        text={player === 1 ? "Victory" : player === 2 ? "Defeat" : "Draw"} 
        score={score} 
        oppScore={oppScore} 
      />
    </div>
  );
}

export default Result;